import { IApiQueryFunction, createApiQueryHook } from "../../utils/api";
import { RelationalValue, mapRelationalValue } from "../../utils/filters";
import { IWorkItem } from "../types/IWorkItem";
import { IWorkResource } from "../types/IWorkResource";

export interface IWorkQueryParameters {
    work: RelationalValue<IWorkResource>;
}

export type IWorkQueryResult = IWorkItem;

export const workQuery: IApiQueryFunction<IWorkQueryParameters> = ({ work }) => {
    return {
        method: "GET",
        url: `/works/${mapRelationalValue(work)}`,
    };
};

export const useWorkQuery = createApiQueryHook<IWorkQueryParameters, IWorkQueryResult>(workQuery);
